export enum SocialMediaPlatformNameId {
  ID = 'id',
  PLATForm = 'platform',
  URL = 'url',
  CREATED_AT = 'createdAt',
}
